import { uri } from '../data-util'
import langs from './language.json'
import { html, render } from 'lit/html.js'

// ----------------------------------------------
// Snippet for Overview
// ----------------------------------------------
export { provider } from './provider'

export { text } from './text'

export { questions } from './questions'